// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'armani',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'ARMANI @ SXSW',
  heroHeadingTwo: '360 VIDEO INSTALLATION / CHATBOT',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle', 'Google Zoo'],
    },
    {
      title: 'BRAND',
      items: ['Giorgio Armani'],
    },
    {
      title: 'PLATFORM',
      items: ['360 Video Projection', 'Dialogflow', 'Firebase', 'Google APIs'],
    },
  ],
  heading: 'COMBINING 360 VIDEO, CHATBOTS AND INTERACTIVE SCREENS TO CREATE AN IMMERSIVE FESTIVAL EXPERIENCE',
  challengeImg: 'challenge.jpg',
  challenge: ['Creating a 360 art installation at SXSW to stimulate interest and awareness of Giorgio Armani’s Films of City Frames campaign.'],
  solutionImg: 'solution.jpg',
  solution: [
    'We created 360 trailers for each of the five films and combined them with specially created tours of the locations, using programmatically-generated Google Earth and Street View content.',
    'We based the tours around the locations used in the films, and introduced relevant supplementary content - quotes related to film themes, information about the location and ‘making of’ footage - to provide a stylish and inspiring experience, all displayed within a 12.5m 360 video dome sourced from Igloo Vision.',
    'To allow visitors to interact with the installation, we created a chatbot for web and Facebook Messenger, that offered an interactive contest with contextual questions synchronised to the content they were watching, and providing them with the opportunity to win Giorgio Armani sunglasses.',
  ],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: '',
      content: ['CREATED FIVE 360 TRAILERS AND CITY EXPLORATIONS.', 'PROGRAMMATICALLY CAPTURED AND COMPILED GOOGLE EARTH AND STREET VIEW CONTENT FOR THE 360 VIDEOS.'],
    },
    {
      img: 'callout_2.jpg',
      title: '',
      content: ['6 INTERACTIVE SCREENS REINFORCED THE SENSATION OF VISITING A MAJOR ART INSTALLATION.'],
    },
    {
      img: 'callout_3.jpg',
      title: '',
      content: ['WROTE SPECIALIST SOFTWARE TO CONTROL SCREENS.'],
    },
    {
      img: 'callout_4.jpg',
      title: '',
      content: ['SOURCED APPROPRIATE CONTENT FROM HUNDREDS OF POSSIBLE OPTIONS.'],
    },
    {
      img: 'callout_5.jpg',
      title: '',
      content: ['CONTEST QUESTIONS SYNCHRONISED WITH INSTALLATION CONTENT TO INCREASE VISITOR ENGAGEMENT.', 'EXPERIENCE SUPPORTED BY DIALOGFLOW CHATBOT-BASED QUIZ.'],
    },
  ],
  nextCaseStudy: 'gic',
};

export default casestudyData;
